module.exports = __webpack_public_path__ + "static/About_Bill_Armstrong-4a5ec92111a1084ca53d82c947dd6f0a.png";